module.exports = __webpack_public_path__ + "img/doc_2_full.e037453d.jpg";